import { subselect } from './root';
import { playerPropertiesSelector } from '../../player/selectors/properties';
import { PLAYER_STATE_STATUSES } from '../../player/constants';

const isReadyToLoadSelector = (playbackSessionState, props, globalState) => {
  const { status } = playerPropertiesSelector(globalState);

  return status === PLAYER_STATE_STATUSES.PLAYING;
};

export const playbackSessionIsReadyToLoadSelector = subselect(isReadyToLoadSelector);
